(function($) {
    'use strict';

    /**
     * Плагин формы авторизации
     * @return {jQuery}
     */

    $.fn.authFormEvents = function () {
        let $self = $('.js-form-reg');
        let $rules = $self.find('.js-rules');
        let $rulesWrapper = $self.find('.js-rules-wrapper');
        let $rulesLink = $self.find('.js-rules-button');
        let $buttonCloseRules = $rules.find('.js-close-rules');
        let $buttonTogglePassword = $self.find('.js-password-button');

        /**
         * Открыть правила
         */
        const openRules = () => $rules.addClass('opened');

        /**
         * Закрыть правила
         */
        const closeRules = () => $rules.removeClass('opened');

        /**
         * Открывает правила при клике на кнопку открытия
         * @param {object} e - события
         */
        const buttonOpenRulesClickHandler = function (e) {
            if (e.target === $rulesLink.get(0) && window.innerWidth < 1280) {
                e.preventDefault();
                openRules();
                SVK.makeFixedHtml();
            }
        };

        /**
         * Закрывает правила при клике на кнопку закрытия
         * * @param {object} e - события
         */
        const buttonCloseRulesClickHandler = function (e) {
            e.preventDefault();
            closeRules();
            SVK.makeUnfixedHtml();
        };

        /**
         * Закрывает правила при клике на оверлей
         * @param {object} e - события
         */
        const overlayRulesClickHandler = function (e) {
            if (!$(e.target).closest($rulesWrapper).length) {
                e.preventDefault();
                closeRules();
                SVK.makeUnfixedHtml();
            }
        };



        /**
         * Закрывает правила по нажатию Escape
         * @param {*} e - события
         */
        const escCloseRules = function (e) {
            if (e.key === 'Escape' && $rules.hasClass('opened')) {
                $rules.removeClass('opened');
                SVK.makeUnfixedHtml();
            }
        }

        /**
         * Переключаем видимость пароля
         */
        const togglePasswordVisibility = function () {

            let $inputPassword = $self.find('#password_input_register');
            let $currentType = $inputPassword.attr('type');

            $inputPassword.attr('type', $currentType === 'text' ? 'password' : 'text');

            if ($inputPassword.attr('type') === 'password') {
                $buttonTogglePassword.removeClass('password-visible').addClass('password-hidden');
            } else {
                $buttonTogglePassword.removeClass('password-hidden').addClass('password-visible');
            }
        };

        /**
         * Инициализация событий
         */
        const initEvents = function () {
            $buttonCloseRules.on('click', buttonCloseRulesClickHandler);
            $rules.on('click', overlayRulesClickHandler);
            $buttonTogglePassword.on('click', togglePasswordVisibility);
            $rulesLink.on('click', buttonOpenRulesClickHandler);
            $(document).on('keydown', escCloseRules);
        };

        /**
         * Инициализация
         */
         const init = function () {
            initEvents();
         };

         init();

        return this;
    };
})(jQuery);
